(function () {
	function swiperInit() {
		// Order matters: sliderInit() reads .swiper off the sublist element for
		// its `thumbs` option, so the sublist has to exist first.
		subSliderInit(true);
		sliderInit(true);
	}

	// Only destroy what is actually there. Calling .destroy() on an element whose
	// Swiper has already gone throws a TypeError, and that aborted the rest of
	// the resize handler — so swiperInit() never ran and the gallery stayed torn
	// down until the page was reloaded.
	function destroySliders(selector) {
		$(selector).each(function () {
			if (this.swiper && !this.swiper.destroyed) {
				this.swiper.destroy();
			}
		});
	}

	// Keep the customer on the slide they were viewing. The product lightbox hides
	// the page scrollbar, which fires resize on desktop and would otherwise snap
	// the gallery back to the first image on close.
	function rebuild() {
		var gallery = document.querySelector('.product-section .js-media-list');
		var activeIndex = gallery && gallery.swiper ? gallery.swiper.activeIndex : 0;

		destroySliders('.product-section .js-media-list');
		destroySliders('.product-section .js-media-sublist');
		swiperInit();

		if (activeIndex && gallery && gallery.swiper) gallery.swiper.slideTo(activeIndex, 0);
	}

	document.addEventListener('shopify:section:load', function () {
		swiperInit();
	});

	// resize fires continuously while a window is dragged — roughly 60 times a
	// second. Rebuilding both galleries on every one of those events locked up
	// the renderer, which is why resizing in devtools appeared to hang the page.
	// Wait for the drag to settle, then rebuild once.
	var resizeTimer;
	// While the lightbox is open the gallery is hidden behind it, and a rebuild
	// would pause the lightbox's video. Closing fires resize again anyway.
	window.addEventListener('resize', function () {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function () {
			if (document.querySelector('product-lightbox[open]')) return;
			rebuild();
		}, 200);
	});

	swiperInit();
})();
